import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import React from 'react';
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Thumbs
} from 'swiper';
import { Swiper } from 'swiper/react';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Thumbs]);

const CustomizedSwiper: React.FC<Swiper> = (props) => {
  const { children, ...rest } = props;

  return <Swiper {...rest}>{children}</Swiper>;
};

export default CustomizedSwiper;
